module.exports = __webpack_public_path__ + "img/cloud-rain-lightning-sun-2.40286061.svg";